import { render, staticRenderFns } from "./dataCashProductDetails.vue?vue&type=template&id=11f1fbff&scoped=true"
import script from "./dataCashProductDetails.vue?vue&type=script&lang=js"
export * from "./dataCashProductDetails.vue?vue&type=script&lang=js"
import style0 from "./dataCashProductDetails.vue?vue&type=style&index=0&id=11f1fbff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f1fbff",
  null
  
)

export default component.exports